import React, { useEffect, useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import MUIRichTextEditor from "mui-rte";
import { ContentState, convertToRaw, convertFromHTML } from "draft-js";
import draftToHtml from "draftjs-to-html";

import { AuthContext } from "../contexts/AuthContext";
import { ScreenContext } from "../contexts/ScreenContext";
import { ClientContext } from "../contexts/ClientContext";
import { AdminContext } from "../contexts/AdminContext";

import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";

import yellow from "@material-ui/core/colors/yellow";
import green from "@material-ui/core/colors/green";
import { Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  noPadding: {
    padding: 0,
  },
  richText: {
    padding: 0,
    paddingLeft: 15,
    paddingRight: 15,
    paddingBottom: 15,
    textAlign: "left",
    backgroundColor: yellow[100],
  },
}));

const MyNotes = (props) => {
  const classes = useStyles();
  const { toggleNote } = props;
  const { token, user } = useContext(AuthContext);
  const { isDesktop } = useContext(ScreenContext);
  const { loadClients, clients } = useContext(ClientContext);
  const { loadUsers, users, isNoteSaving, saveMyNotes, getMyNotes, myNotes } =
    useContext(AdminContext);
  const [autocompleteClients, setAutocompleteClients] = useState([]);
  const [autocompleteUsers, setAutocompleteUsers] = useState([]);
  const [myNote, setMyNote] = useState("");
  const [isInit, setIsInit] = useState(false);

  const handleComment = (data) => {
    //let cmt = draftToMarkdown(convertToRaw(data.getCurrentContent()));
    let rteContent = convertToRaw(data.getCurrentContent());
    let markup = draftToHtml(rteContent);


    saveMyNotes(isInit, markup);
  };

  useEffect(() => {
    if (myNotes.length) {
      const contentHTML = convertFromHTML(myNotes[0].Note);
      const state = ContentState.createFromBlockArray(
        contentHTML.contentBlocks,
        contentHTML.entityMap
      );
      const content = JSON.stringify(convertToRaw(state));

      setMyNote(content);
      setIsInit(true);
    }
  }, [myNotes]);

  useEffect(() => {
    if (clients.length > 0) {


      let array = [];
      clients.map((item, index) => {
        let arrayItem = {};
        arrayItem.keys = [
          `${(item.Name||'').toLowerCase()}`,  
          `${item.ID}`,
          `${(item.Name||'').split(" ").join("").toLowerCase()}`,
        ];
        arrayItem.value = `[${item.ID} | ${item.Name}]`;
        arrayItem.content = `[${item.ID} | ${item.Name}]`;

        array.push(arrayItem);
      });


      setAutocompleteClients(array);
    }
  }, [clients]);

  useEffect(() => {
    if (users.length > 0) {
      let array = [];
      users.map((item, index) => {
        let arrayItem = {};
        arrayItem.keys = [
          `${item.first_name.toLowerCase()}`,
          `${item.last_name.toLowerCase()}`,
          `${item.username.toLowerCase()}`,
        ];
        arrayItem.value = `[${item.username} | ${item.first_name} ${item.last_name}]`;
        arrayItem.content = `[${item.username} | ${item.first_name} ${item.last_name}]`;

        array.push(arrayItem);
      });


      setAutocompleteUsers(array);
    }
  }, [users]);

  useEffect(() => {
    setIsInit(false);
    loadUsers(true);
    getMyNotes();
    loadClients();


    return () => {
      setIsInit(false);
    };
  }, []);

  return (
    <React.Fragment>
      <Paper
        className={clsx(classes.paper, classes.richText)}
        elevation={0}
        variant="outlined"
      >
        <Grid container justifyContent="space-between">
          <Grid item style={{ marginTop: 10, marginBottom: -5 }}>
            <Typography
              align="left"
              style={{ marginTop: 15 }}
              variant="h6"
              display="inline"
              gutterBottom
            >{`myNOTES:`}</Typography>
            {isNoteSaving ? (
              <Typography
                align="left"
                style={{ marginTop: 9, color: green[700] }}
                variant="overline"
                display="inline"
                gutterBottom
              >{` Saving...`}</Typography>
            ) : (
              <Typography
                align="left"
                style={{ marginTop: 9, color: green[700] }}
                variant="overline"
                display="inline"
                gutterBottom
              >{` `}</Typography>
            )}
          </Grid>
          <Grid item>
            <Grid
              container
              justifyContent="flex-end"
              style={{ marginTop: 15, marginBottom: -15 }}
            >
              <Grid item>
                <IconButton 
                  onClick={toggleNote} 
                  style={{ padding: 0 }}
                  aria-label="Close my notes"
                >
                  <Icon fontSize="small">cancel</Icon>
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <MUIRichTextEditor
          label="Type @client and #user..."
          defaultValue={myNote}
          onChange={(data) => handleComment(data)}
          autocomplete={{
            strategies: [
              {
                items: autocompleteUsers,
                triggerChar: "#",
              },
              {
                items: autocompleteClients,
                triggerChar: "@",
              },
            ],
          }}
          controls={[
            "bold",
            "italic",
            "underline",
            "bulletList",
            "numberList",
            "link",
          ]}
        />
      </Paper>
    </React.Fragment>
  );
};

export default MyNotes;
